import _ from "lodash";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import { compose } from "lib/apolloClient";

import {
  logoutUser,
  setGlobalTrayEnabledState,
} from "Login/modules/LoginModule";
import { onUserCommunicationEnumSelect } from "Teacher/modules/TeacherModule";
import TopHeader from "Courses/components/ParentHomePage/TopHeader";
import ChildDropDown from "Courses/components/ParentHomePage/ChildDropDown";

import StudentBlock from "./StudentBlock";

import classes from "./StudentBlockScreen.scss";

const StudentBlockScreen = props => {
  const {
    userCurriculumPrograms,
    studentName,
    studentBlockMsg,
    onUserCommunicationEnumSelect,
    logoutUser,
    setGlobalTrayEnabledState,
  } = props;

  useEffect(() => {
    setGlobalTrayEnabledState(false);
    return () => setGlobalTrayEnabledState(true);
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <TopHeader
          logoutUser={logoutUser}
          onUserMessageClick={onUserCommunicationEnumSelect}
        />
      </div>
      <div className={classes.bodyContainer}>
        <ChildDropDown
          userCurriculumPrograms={userCurriculumPrograms}
          renderChildBox={() => null}
        />
        <StudentBlock
          studentName={studentName}
          studentBlockMsg={studentBlockMsg}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const studentName = _.get(state, "login.userInfo.childName");
  const childBlockedMessage = _.get(
    state,
    "login.userInfo.childBlockedMessage"
  );
  return {
    studentName,
    studentBlockMsg: childBlockedMessage,
  };
};

const mapActionCreators = {
  logoutUser,
  onUserCommunicationEnumSelect,
  setGlobalTrayEnabledState,
};

export default compose(connect(mapStateToProps, mapActionCreators))(
  StudentBlockScreen
);
